import HeroSection from '../../Hero/Hero';

const Home = () => {
  return (
    <div>
      <HeroSection />
    </div>
  );
};

export default Home;
